/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import { __asyncDelegator, __asyncGenerator, __asyncValues, __await } from "tslib";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
/// <reference lib="esnext.asynciterable" />
/** Class containing SubscriptionPolicy operations. */
export class SubscriptionPolicyImpl {
    /**
     * Initialize a new instance of the class SubscriptionPolicy class.
     * @param client Reference to the service client
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Get the subscription tenant policy for the user's tenant.
     * @param options The options parameters.
     */
    listPolicyForTenant(options) {
        const iter = this.listPolicyForTenantPagingAll(options);
        return {
            next() {
                return iter.next();
            },
            [Symbol.asyncIterator]() {
                return this;
            },
            byPage: () => {
                return this.listPolicyForTenantPagingPage(options);
            }
        };
    }
    listPolicyForTenantPagingPage(options) {
        return __asyncGenerator(this, arguments, function* listPolicyForTenantPagingPage_1() {
            let result = yield __await(this._listPolicyForTenant(options));
            yield yield __await(result.value || []);
            let continuationToken = result.nextLink;
            while (continuationToken) {
                result = yield __await(this._listPolicyForTenantNext(continuationToken, options));
                continuationToken = result.nextLink;
                yield yield __await(result.value || []);
            }
        });
    }
    listPolicyForTenantPagingAll(options) {
        return __asyncGenerator(this, arguments, function* listPolicyForTenantPagingAll_1() {
            var e_1, _a;
            try {
                for (var _b = __asyncValues(this.listPolicyForTenantPagingPage(options)), _c; _c = yield __await(_b.next()), !_c.done;) {
                    const page = _c.value;
                    yield __await(yield* __asyncDelegator(__asyncValues(page)));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) yield __await(_a.call(_b));
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }
    /**
     * Create or Update Subscription tenant policy for user's tenant.
     * @param body Put tenant policy request properties.
     * @param options The options parameters.
     */
    addUpdatePolicyForTenant(body, options) {
        return this.client.sendOperationRequest({ body, options }, addUpdatePolicyForTenantOperationSpec);
    }
    /**
     * Get the subscription tenant policy for the user's tenant.
     * @param options The options parameters.
     */
    getPolicyForTenant(options) {
        return this.client.sendOperationRequest({ options }, getPolicyForTenantOperationSpec);
    }
    /**
     * Get the subscription tenant policy for the user's tenant.
     * @param options The options parameters.
     */
    _listPolicyForTenant(options) {
        return this.client.sendOperationRequest({ options }, listPolicyForTenantOperationSpec);
    }
    /**
     * ListPolicyForTenantNext
     * @param nextLink The nextLink from the previous successful call to the ListPolicyForTenant method.
     * @param options The options parameters.
     */
    _listPolicyForTenantNext(nextLink, options) {
        return this.client.sendOperationRequest({ nextLink, options }, listPolicyForTenantNextOperationSpec);
    }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);
const addUpdatePolicyForTenantOperationSpec = {
    path: "/providers/Microsoft.Subscription/policies/default",
    httpMethod: "PUT",
    responses: {
        200: {
            bodyMapper: Mappers.GetTenantPolicyResponse
        },
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    requestBody: Parameters.body3,
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept, Parameters.contentType],
    mediaType: "json",
    serializer
};
const getPolicyForTenantOperationSpec = {
    path: "/providers/Microsoft.Subscription/policies/default",
    httpMethod: "GET",
    responses: {
        200: {
            bodyMapper: Mappers.GetTenantPolicyResponse
        },
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept],
    serializer
};
const listPolicyForTenantOperationSpec = {
    path: "/providers/Microsoft.Subscription/policies",
    httpMethod: "GET",
    responses: {
        200: {
            bodyMapper: Mappers.GetTenantPolicyListResponse
        },
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept],
    serializer
};
const listPolicyForTenantNextOperationSpec = {
    path: "{nextLink}",
    httpMethod: "GET",
    responses: {
        200: {
            bodyMapper: Mappers.GetTenantPolicyListResponse
        },
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host, Parameters.nextLink],
    headerParameters: [Parameters.accept],
    serializer
};
//# sourceMappingURL=subscriptionPolicy.js.map